var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4342B",
    d: "M0 0h56v56H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.4 14.484a1 1 0 01.98-.301l21.1 5.166c.127.031.246.087.352.163l4.293 3.13a1 1 0 01.236 1.372l-14.77 21.61a1 1 0 01-1.769-.23L15.2 15.49a1 1 0 01.2-1.005zm3.482 5.397l7.374 20.76 1.213-10.759-8.587-10.001zm10.56 10.348L28.21 41.175 38.64 25.912l-9.199 4.317zm10.139-6.967l-6.723 3.155 4.507-4.77 2.216 1.615zm-4.246-2.379L18.93 16.866l9.618 11.202 6.788-7.185z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrxLogo);
export default __webpack_public_path__ + "static/media/trx-logo.f06ae8d1d1fe6d92357bf57148e10c1a.svg";
export { ForwardRef as ReactComponent };